import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf24.png';

const MarketShareStep20 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Capacity Constraint"
    paragraph2={(
      <Fragment>
        Capacity constraints could be the reason why your company was unable to manufacture more
        goods available for sale. For example, Operations might have produced the maximum units
        possible given the production machine used.<br />
        It should be noted that your product's design release date and your machine choice
        impacts production capacity.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep20;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step20.js